import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import '@fontsource-variable/inter';

import { AppProviders } from '@/app/AppProviders';
// i18next has to be initialised, and the detected language loaded, before the
// first component calls `t` (spec §8.9).
import { languageReady } from '@/i18n';
import { router } from '@/app/router';
import { env } from '@/lib/env';
import { registerServiceWorker } from '@/lib/pwa';

async function startMockServiceWorker(): Promise<void> {
  // `import.meta.env.DEV` is inlined as `false` for production builds, which
  // makes the dynamic import below unreachable and keeps MSW out of dist/.
  if (!import.meta.env.DEV || !env.VITE_ENABLE_MSW) return;
  const { worker } = await import('@/mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

void registerServiceWorker();

void Promise.all([languageReady, startMockServiceWorker()]).then(() => {
  createRoot(container).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} future={{ v7_startTransition: true }} />
      </AppProviders>
    </StrictMode>,
  );
});
